import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  pizzaBases: {
    data: [],
    loading: false,
  },
  selectedPizzaBase: {
    data: {},
    loading: false,
  },
};

export const getPizzaBases = createAsyncThunk(
  "pizzaDough/getPizzaBases",
  async () => {
    try {
      const response = await httpClient.get("/web/pizza-bases");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const createPizzaBase = createAsyncThunk(
  "pizzaDough/createPizzaBase",
  async (pizzaBase) => {
    try {
      const response = await httpClient.post("/web/pizza-base", pizzaBase);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const updatePizzaBase = createAsyncThunk(
  "pizzaDough/updatePizzaBase",
  async (pizzaBase) => {
    try {
      const response = await httpClient.put(
        `/web/pizza-base/${pizzaBase._id}`,
        pizzaBase.data
      );
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getPizzaBaseyId = createAsyncThunk(
  "pizzaDough/getPizzaBaseyId",
  async (id) => {
    try {
      const response = await httpClient.get(`/web/pizza-base/${id}`);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const pizzaBaseSlice = createSlice({
  name: "pizzaBase",
  initialState,
  reducers: {
    initiSelectedPizzaBase: (state) => {
      state.selectedPizzaBase.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPizzaBases.pending, (state) => {
        state.pizzaBases.loading = true;
      })
      .addCase(getPizzaBases.fulfilled, (state, action) => {
        state.pizzaBases.loading = false;
        state.pizzaBases.data = action.payload;
      })
      .addCase(getPizzaBases.rejected, (state) => {
        state.pizzaBases.loading = false;
      })
      .addCase(updatePizzaBase.pending, (state) => {
        state.selectedPizzaBase.loading = true;
      })
      .addCase(updatePizzaBase.fulfilled, (state, action) => {
        state.selectedPizzaBase.loading = false;
        state.selectedPizzaBase.data = action.payload;
      })
      .addCase(updatePizzaBase.rejected, (state) => {
        state.selectedPizzaBase.loading = false;
      })
      .addCase(getPizzaBaseyId.pending, (state) => {
        state.selectedPizzaBase.loading = true;
      })
      .addCase(getPizzaBaseyId.fulfilled, (state, action) => {
        state.selectedPizzaBase.loading = false;
        state.selectedPizzaBase.data = action.payload;
      })
      .addCase(getPizzaBaseyId.rejected, (state) => {
        state.selectedPizzaBase.loading = false;
      })
      .addCase(createPizzaBase.pending, (state) => {
        state.pizzaBases.loading = true;
      })
      .addCase(createPizzaBase.fulfilled, (state, action) => {
        state.pizzaBases.loading = false;
        state.pizzaBases.data.push(action.payload);
      })
      .addCase(createPizzaBase.rejected, (state) => {
        state.pizzaBases.loading = false;
      });
  },
});

export const { initiSelectedPizzaBase } = pizzaBaseSlice.actions;

export default pizzaBaseSlice.reducer;
